export default __webpack_public_path__ + "static/media/Parallax-HUD-Dock.833507d4.jpg";